import slug from "speakingurl";

export const createSlug = (title: string) => {
  return slug(title, {
    lang: "tr",
  });
};
